var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgZoomOut(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20.653,
    height: 20.588,
    viewBox: "0 0 20.653 20.588",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "ico-zoom-out",
    transform: "translate(-14.128 -144.8)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_176",
    "data-name": "Path 176",
    d: "M158.437,163.992l-5.954-5.954a7.69,7.69,0,1,0-.745.745l5.954,5.954a.525.525,0,0,0,.377.151.554.554,0,0,0,.377-.151A.528.528,0,0,0,158.437,163.992Zm-7.018-6.356a.788.788,0,0,1-.084.084,6.633,6.633,0,1,1,1.985-4.732A6.558,6.558,0,0,1,151.419,157.636Z",
    transform: "translate(-124.372)",
    fill: "#010101",
    stroke: "#000",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_177",
    "data-name": "Path 177",
    d: "M286.384,292.6a.791.791,0,0,1-.084.084.1.1,0,0,1,.042-.042Z",
    transform: "translate(-259.336 -134.964)",
    fill: "#010101",
    stroke: "#000",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_178",
    "data-name": "Path 178",
    d: "M199.736,231.855h-5.108a.528.528,0,1,1,0-1.055h5.108a.528.528,0,1,1,0,1.055Z",
    transform: "translate(-174.857 -78.34)",
    fill: "#010101",
    stroke: "#000",
    strokeWidth: 1
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgZoomOut);
export default __webpack_public_path__ + "static/media/zoomOut.299ab49cc57dfb0dbec94f5b23f6f87f.svg";
export { ForwardRef as ReactComponent };